import { ProfileType, TermType } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import store from '@/store';
import { LocalStorage } from '@/enums/storage.enum';

export const applicationRoute: RouteConfig = {
  path: 'application',
  name: 'application',
  component: () => import(/* webpackChunkName: "Router" */ '@/views/main/application/Create.vue'),
  beforeEnter(to, from, next) {
    store.commit('profile/setId', localStorage.getItem(LocalStorage.USER_ID));
    Promise.all([
      store.dispatch('profile/get'),
      store.dispatch('collectionPoint/list'),
      store.dispatch('card/list'),
      store.dispatch('terms/getCurrent', { profileType: ProfileType.CLIENT, type: TermType.APPLICATION })
    ]).then(() => next());
  }
};
